(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-glx-search-trigger]');
  if (!trigger) return;
  const input = [...document.querySelectorAll('.header__search-input')].find((field) => field.getClientRects().length);
  if (!input) {
    window.location.assign(trigger.dataset.searchUrl);
    return;
  }
  input.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  input.focus({ preventScroll: true });
  input.click();
});

  } catch(e) { console.error(e); }
})();
})();
